import { CompanyContextLink } from "./company-context-link/company-context-link.pipe";
import { DateFormatPipe } from "./date-format/date-format.pipe";
import { BadgeTextPipe } from "./element/badge-text.pipe";
import { MapKeyValuePipe } from "./key-value/key-value.pipe";
import { MatchPipe } from "./match/match.pipe";
import { AbsoluteNumberPipe } from "./number/absolute-number.pipe";
import { CurrencyPipe } from "./number/currency.pipe";
import { RawDatePipe } from "./raw-date/raw-date.pipe";
import { TranslatePipe } from "./translate/translate.pipe";
import { TrustResourcePipe } from "./trust-resource/trust-resource.pipe";

export const pipeProviders = [
	DateFormatPipe,
	BadgeTextPipe,
	MapKeyValuePipe,
	MatchPipe,
	AbsoluteNumberPipe,
	CurrencyPipe,
	RawDatePipe,
	TranslatePipe,
	TrustResourcePipe,
	CompanyContextLink
];
